import React from 'react'
import {  
    useColorModeValue,  
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    PopoverArrow,
    Button,
    Text,
    Box,
  } from '@chakra-ui/react';

export function ButtonPopver({title, children, colorB}) {
    const popoverBg = useColorModeValue('rgba(255, 255, 255, 0.9)', 'rgba(15, 23, 42, 0.9)');
    const borderColor = useColorModeValue('gray.100', 'whiteAlpha.200');
    const shadowColor = useColorModeValue('rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.4)');

    return (
        <Popover trigger="hover" placement="bottom-start" gutter={12}>
        <PopoverTrigger>
          <Button 
            variant='ghost' 
            h="40px" // Sincronizado com LinkButton
            px={4} 
            borderRadius="full"
            _hover={{ bg: useColorModeValue('brand.50', 'whiteAlpha.100') }}
            _active={{ bg: 'transparent' }}
          >
            <Text 
                color={colorB} 
                fontSize="xs" // Sincronizado com LinkButton
                fontWeight="800" 
                letterSpacing="tighter"
                textTransform="uppercase"
                transition="all 0.2s"
            >
                {title}
            </Text>
          </Button>
        </PopoverTrigger>
        <PopoverContent 
            bg={popoverBg} 
            backdropFilter="blur(15px)"
            border="1px solid"
            borderColor={borderColor}
            borderRadius="2xl"
            boxShadow={`0 15px 40px ${shadowColor}`}
            _focus={{ outline: 'none' }}
        >
          <PopoverArrow bg={popoverBg} />
          <PopoverBody p={2}>
            <Box>
                {children}
            </Box>
          </PopoverBody>
        </PopoverContent>
      </Popover>  
    );
}

export default ButtonPopver;